import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";
import { fetchItemById } from "../../store/actions/items";
import { PATHS } from "../../common/constants";
import { selectItemById } from "../../store/selectors/items";
import { setItemFormData } from "../../store/actions/itemForm";
import Breadcrumb from "../../components/Breadcrumb";
import Button from "../../components/Button";
import Card from "../../components/Card";
import HeadingWithDetails from "../../components/HeadingWithDetails";
import Icon from "../../components/Icon";
import ItemDocuments from "./ItemDocuments";
import ItemMaintenanceGuide from "./ItemMaintenanceGuide";
import ItemFaqs from "./ItemFaqs";
import ItemForm from "../../components/ItemForm";
import ItemNotes from "./ItemNotes";
import ItemCommonIssues from "./ItemCommonIssues";
import Loader from "../../components/Loader";
import Metrics from "../../components/Metrics";
import Overlay from "../../components/Overlay";
import Tabs from "../../components/Tabs";
import Warranty from "../../components/Warranty";
import WithNavigation from "../../layouts/WithNavigation";
import { fetchFaqsNotesDocuments} from "../../store/actions/faqsNotesDocuments";
import { clearServiceRequests } from "../../store/actions/serviceRequests";
import { fetchAllIssueTypes } from "../../store/actions/formOptions";
import { deleteItem, updateItem } from "../../store/actions/items";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import ItemServiceRequest from "./ItemServiceRequest";
import { fetchCommonIssues } from "../../store/actions/CommonIssues";
import { selectCommonIssues } from "../../store/selectors/CommonIssues";
import ItemSpecifications from "./ItemSpecifications";
import {selectNotes} from "../../store/selectors/faqsNotesDocuments";
import { BrandingContext } from "../../branding/BrandingContextProvider";

class Item extends Component {
  state = {
    showOverlay: false,
  };

  componentDidMount() {
    const {
      onFetchItemFaqsAndNotes,
      onFetchAllIssueTypes,
      item,
      clearServiceRequests,
      onFetchCommonIssues,notes
    } = this.props;
    clearServiceRequests();
    onFetchItemFaqsAndNotes(item.id);
    onFetchAllIssueTypes();
    onFetchCommonIssues(item.id);
    let HmeOwnrOcpntRltrNotes=[];
    if(notes!=undefined && notes!=null && notes!="" && notes.length >0){
      let notesList= notes.filter(x=>x.documentType=="NOTES");
      if(notesList.length >0){
        notesList.forEach((object) => {HmeOwnrOcpntRltrNotes.push(JSON.parse(JSON.parse(JSON.stringify(object.data)))); });
      }
      if(HmeOwnrOcpntRltrNotes.length >0){
        let filterNotes=HmeOwnrOcpntRltrNotes.filter(x=>x.noteVisibleToHomeownerOccupantRealtor==true);
        if(filterNotes.length >0){
          this.setState({ noteVisibleToHomeownerOccupantRealtor: true });
        }
      }
    } 
  }
  onSaveItem = (item) => {
    let params = {};
    let { onUpdateItem } = this.props;
    let properties = [];
    if (item.selectedProperties && item.selectedProperties.length > 0) {
      item.selectedProperties.map((sp) => {
        properties = [...properties, { id: sp.value }];
      });
    }
    if (item.id) {
      params = {
        id: item.id,
        name: item.name,
        MakeName: item.makeName,
        model: item.model,
        TypeId: item.typeId,
        warrantyYears: item.warrantyYears,
        UserId: this.props.user.id,
        properties: properties,
      };
      onUpdateItem(params);
    }
  };

  onDeleteItem = (data) => {
    this.props.onDeleteItem(data.id, this.props.history);
  };

  static contextType = BrandingContext;

  render() {
    const { onSetItemFromData, item, commonIssues } = this.props;
    // let item = this.props.location.state.item;
    const { showOverlay } = this.state;
    let {noteVisibleToHomeownerOccupantRealtor}=this.state;
    const {branding} = this.context;
    const user = JSON.parse(localStorage.getItem('user'));
   let roleName = user.roles[0].role.name;
    if (item) {
      return (
        <WithNavigation
          title={item.name}
          top={
            <HeadingWithDetails
              breadcrumb={<Breadcrumb to={PATHS.ITEMS_LIST} label="Catalog" />}
              headline={item.name}
              items={[
                <Card
                  body={
                    <>
                      MAKE: {item && item.makeName ? item.makeName : "—"} <br />
                      MODEL: {item && item.model ? item.model : "—"} <br />
                      TYPE: {item.typeName}
                    </>
                  }
                />,
                <Metrics
                  items={[
                    {
                      value: item.serviceRequestsCount,
                    },
                  ]}
                />,
                <Card
                  title="Warranty Plan"
                  body={<Warranty duration={item.warrantyYears} />}
                />,
              ]}
              actions={
                this.props.user.roles[0].role.name ===
                "Strata Manager" ? null : (
                  <>
                    <Button
                      color="semantic"
                      onClick={() => {
                        this.setState({ showOverlay: true });
                        onSetItemFromData({
                          ...item,
                          selectedProperties: item.properties.map((pty) => ({
                            value: pty.id,
                            label: pty.name,
                          })),
                        });
                      }}
                      label={<Icon glyph="pencil" weight="light" />}
                    />
                    <Button
                      color="semantic"
                      onClick={() =>
                        window.confirm(
                          `Are you sure you want to delete ${item.name}?`
                        ) && this.onDeleteItem(item)
                      }
                      label={<Icon glyph="trash" weight="light" />}
                    />
                    <Overlay
                      showOverlay={showOverlay}
                      content={
                        <ItemForm
                          onClose={() => this.setState({ showOverlay: false })}
                          onSaveItem={this.onSaveItem}
                          onDeleteItem={this.onDeleteItem}
                        />
                      }
                    />
                  </>
                )
              }
            />
          }
          bottom={
            <Tabs
              from={'Catalog'}
              items={[
                
                {
                  label: "Specifications",
                  count: item.faq_count,
                  content: <ItemSpecifications item={item} onEditSpecification={this.editSpecification}/>,
                },
                {
                  label: "FAQs",
                  count: item.faq_count,
                  content: <ItemFaqs item={item} />,
                },
                ((roleName === "Occupant" || roleName === "Realtor" || roleName==="Home Owner") && noteVisibleToHomeownerOccupantRealtor==false)
                ?{}:
                {
                  label: "Notes",
                  count: item.note_count,
                  content: <ItemNotes item={item} />,
                },
                {
                  label: "Manuals & Documents",
                  count: item.document_count,
                  content: <ItemDocuments item={item} />,
                },
                {
                  label: branding.text.serviceRequest+"s",
                  count: item.document_count,
                  content: <ItemServiceRequest item={item} />,
                },
                {
                  label: "Maintenance Reminders",
                  count: item.document_count,
                  content: <ItemMaintenanceGuide item={item} />,
                },
                {
                  label: "Common Issues",
                  count: commonIssues.length.toString(),
                  content: (
                    <ItemCommonIssues item={item} commonIssues={commonIssues} />
                  ),
                },
              ]}
            />
          }
        />
      );
    }

    return <Loader />;
  }
}

const mapStateToProps = (state, ownProps) => ({
  item: selectItemById(state, ownProps.match.params.id),
  user: selectAuthenticatedUser(state),
  commonIssues: selectCommonIssues(state),
  notes: selectNotes(state)
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearServiceRequests,
      onFetchItemById: fetchItemById,
      onFetchItemFaqsAndNotes: fetchFaqsNotesDocuments,
      onSetItemFromData: setItemFormData,
      onFetchAllIssueTypes: fetchAllIssueTypes,
      onFetchCommonIssues: fetchCommonIssues,
      onDeleteItem: deleteItem,
      onUpdateItem: updateItem,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Item);
